<script setup lang="ts">
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

const props = defineProps<{
  title: string
}>()

const { mdAndDown } = useDisplay()
const isMobile = computed(() => mdAndDown.value)
</script>

<template>
  <div class="simple-card" :class="{ 'simple-card--mobile': isMobile }">
    <div class="simple-card-header">
      <p class="simple-card-title">{{ props.title }}</p>

      <slot name="append" />
    </div>

    <div class="simple-card-body">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.simple-card {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-right: 24px;
  padding-left: 24px;
  margin: 24px 0;
  background: white;
  display: flex;
  flex-direction: column;
}

/* HEADER */
.simple-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center; /* centraliza verticalmente texto + botão */
}

/* TÍTULO */
.simple-card-title {
  margin: 0; /* <--- remove margem do <p> */
  color: rgba(0, 0, 0, 0.87);
  font-family: 'Open Sans';
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.05px;
}

/* MOBILE */
.simple-card--mobile {
  border: none;
  border-radius: 0;
  background: transparent;

  padding: 16px !important;
  margin: 16px 0 !important;
}

@media (max-width: 600px) {
  .simple-card {
    padding-top: 16px;
    padding-bottom: 16px;
    padding-right: 16px;
    padding-left: 16px;
  }
}
</style>
